import { config } from '../../config';
import cn from 'classnames';
import React from 'react';
export var PageChatBlocked = function () {
    var B = config.css.B('-page-chat');
    return (React.createElement("div", { className: cn(B), style: { margin: '20px', display: 'flex' } },
        React.createElement("div", { className: cn("".concat(B, "__messages")), id: "scrollContainer" },
            React.createElement("pre", { style: {
                    padding: '10px',
                    fontSize: '13px',
                    background: '#ffc',
                } },
                React.createElement("strong", { style: { color: 'darkred' } }, "Error"),
                React.createElement("div", { style: { whiteSpace: 'pre-wrap', color: 'gray' } }, "Aktu\u00E1ln\u011B nen\u00ED mo\u017En\u00E9 vyu\u017E\u00EDvat chatovou komunikaci.")))));
};
